/**
 * Application Configuration
 *
 * Environment detection:
 * - NODE_ENV is set automatically by React Scripts
 * - 'development' when running `npm start`
 * - 'production' when running `npm run build`
 *
 * Database access:
 * - Supabase: Same cloud database for all environments (auth, user data)
 * - Backend API: Different URLs for local vs production (vector DB, file storage)
 */

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://puefpwmanaytafqtlfwh.supabase.co';
const apiUrl = process.env.REACT_APP_API_URL || 'https://api.complydeck.com';

export const config = {
  // Environment info
  env: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',

  // App URL - for auth redirects
  appUrl: process.env.REACT_APP_APP_URL || (process.env.NODE_ENV === 'production' ? 'https://app.complydeck.com' : 'http://localhost:3000'),

  // Backend API (FastAPI) - for vector DB, file storage, CSV processing
  apiUrl: apiUrl,

  // Supabase Edge Functions URL
  // In production: route through API proxy (api.complydeck.com/functions/v1)
  // In development: call Supabase directly (local backend doesn't proxy functions)
  functionsUrl: process.env.NODE_ENV === 'production'
    ? `${apiUrl}/functions/v1`
    : `${supabaseUrl}/functions/v1`,

  // Supabase (cloud) - for auth, user profiles, projects, invites
  supabase: {
    url: supabaseUrl,
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB1ZWZwd21hbmF5dGFmcXRsZndoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4NzQzNzcsImV4cCI6MjA4MTQ1MDM3N30.dVMNALBYX1g88hNG8jDor-lIQAyrzcmHVMiirzEvWqM',
  },
};

// Log config on startup (only in development)
if (config.isDevelopment) {
  console.log('🔧 App Configuration:', {
    environment: config.env,
    apiUrl: config.apiUrl,
    functionsUrl: config.functionsUrl,
    supabaseUrl: config.supabase.url,
  });
}

export default config;

